import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { sendContactusEmail } from 'src/config/firebase';
import {SectionTitle} from '../components/SectionTitle';
import SocialIcons from '../../shared/components/SocialIcons';
import { CircularProgress, Backdrop, TextField, Button } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import makeStyles from '@mui/styles/makeStyles';
import Header from '../components/Header';
import { useCompanyData } from '../../shared/contexts/DataContext';
import { AlertMessage } from 'src/screens/Partners/Service/components';
import Map from '../../shared/components/Map';
import { contactImage } from '../../shared/logic/imagesFns';
import { textVariant, textClasses } from '../../shared/config';

const ColorCircularProgress = withStyles({
  root: {
    color: '#0F467A',
  },
})(CircularProgress);

const useStyles = makeStyles((theme) => ({
  myLabel: {
    color: '#0A0945',
    opacity: '0.6',
    transform:"translate(14px, 12px) scale(1)",
    '&.Mui-focused':{
      fontWeight:'bold',
      color:'#0A0945 !important'
    },
  },

  _inputCl:{
    padding:'12px 14px'
  },

  iconDiv:{
    width:'63px',
    height:'63px',

    '& img':{
      width:'100%',
      height:'100%'
    }
  },

  focusedCl:{
    borderColor:'#0A0945 !important',
    '&.MuiOutlinedInput-notchedOutline':{
      borderColor:'#0A0945 !important'
    }
  },

  contactList:{
    width:"30%",
    minWidth:"300px",
    marginRight:'24px',
    [theme.breakpoints.between('xs', 'md')]: {
      width:'100%',
      marginRight:'0px'
    }
  },

  formDiv:{
    width:'60%',
    minWidth:"300px",
    [theme.breakpoints.between('xs', 'md')]: {
      width:'100%',
    }
  },

  backdrop: {
    zIndex: 111125,
    color: '#fff',
  },
}));

const Contact = () => {
  const { data } = useCompanyData();
  const { companyData } = data;
  const { facebookPage, instagramPage, twitterPage, description } =
    companyData || {};
  const { t,fontFamily } = data;
  const visibleMap = data && data.map !== undefined ? data.map : true;
  const classes = useStyles();

  useEffect(()=> {
    window.scrollTo(0, 0);
  },[])

  return (
    <div>
      <SimpleHeader
        {...{title:t && t('companyPage.contactus'),data}}
      />
      {/* <Header
        image={contactImage(data,'t3')}
        height="280px"
        transparencyColor={'#15476db2'}
        bannerStyle={data.bannerStyle ? data.bannerStyle : 'boxed'}
        displayBanner={data.displayBanner}
        data={data}
        position="relative"
      >
        <div>
          <Box pb={7}>
            <Typography
              variant="h2"
              style={{ color: 'white', fontWeight: 'bold',textTransform:'capitalize', fontFamily }}
            >
              {t && t('companyPage.contactus')}
            </Typography>
          </Box>
        </div>
      </Header> */}
      <Details
        facebookPage={facebookPage}
        instagramPage={instagramPage}
        twitterPage={twitterPage}
        description={description}
        t={t}
        data={data}
      />
      {companyData?.longitude && visibleMap && <Location companyData={companyData} />}
    </div>
  );
};

function SimpleHeader({title, data}) {
  const { fontFamily, displayBanner=true, generalTitleFontSize } = data;
  const variant = generalTitleFontSize && textVariant?.[generalTitleFontSize] ? textVariant?.[generalTitleFontSize] : textVariant?.['62'];
  
  const fontSizeCls = generalTitleFontSize && textClasses?.[generalTitleFontSize] ? textClasses?.[generalTitleFontSize] : textClasses?.['62'];
  return(
    <Header
      image={contactImage(data,'t3')}
      height="280px"
      transparencyColor={'#15476db2'}
      bannerStyle={data.bannerStyle ? data.bannerStyle : 'boxed'}
      displayBanner={displayBanner}
      data={data}
      position="relative"
    >
      <div style={{zIndex:1}}>
        <Box pb={7}>
          <Typography
             variant={variant}
             className={fontSizeCls}
            style={{ color: 'white', fontWeight: 'bold',textTransform:'capitalize', fontFamily }}
          >
            {title}
          </Typography>
        </Box>
      </div>
    </Header>
  )
}

const Details = ({
  facebookPage,
  instagramPage,
  twitterPage,
  t,
  data
}) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    subject: '',
    content: '',
  });

  const [message,setMessage] = useState('');
  const [alertType,setAlertType] = useState('');
  const [openAlert,setAlert] = useState(false);
  const [loading,setLoading] = useState(false);


  const { address, phoneNumber, city, email } = data?.companyData || {};

  const visiblePhone = data.phone;
  const visibleMap = data && data.map !== undefined ? data.map : true;
  const classes = useStyles();

  const showAlert = (message,alertType) => {
    setMessage(message);
    setAlertType(alertType);
    setAlert(true);
  };

  const closeAlert = () => {
    setMessage('');
    setAlertType('');
    setAlert(false);
  };

  const sendEmail = () => {

    if(!formData?.firstName) {
      showAlert('Please enter first Name','error')
    }
    else if(!formData?.lastName) {
      showAlert('Please enter last Name','error')
    }
    else if(!formData?.email) {
      showAlert('Please enter valid email','error')
    }
    else if(!formData?.phone) {
      showAlert('Please enter valid phone number','error')
    }
    else if(!formData?.subject) {
      showAlert('Please enter message title','error')
    }
    else if(!formData?.content) {
      showAlert('Please enter message','error')
    }
    else{
      setLoading(true);

      const dataObj = { 
        name: `${formData?.firstName} ${formData?.lastName}`,
        ...formData,
        companyId: data?.companyData?.id
      }

      sendContactusEmail(dataObj)
      .then(msg=> {
        setLoading(false);
        setFormData({
          firstName: '',
          lastName:'',
          email: '',
          phone: '',
          subject: '',
          content: '',
        });
        showAlert('your message has been sent!','success')
      })
      .catch(errMsg=> {
        setLoading(false);
        showAlert(errMsg,'success')
      })
    }
  };

  return (
    <Box
      width="90%"
      m="auto"
      py={5}
      display="flex"
      justifyContent="space-between"
      flexWrap="wrap"
      mt="100px"
    >
      <Box width={{ xs: '100%', md: '40%' }}>
        <SectionTitle pb={4}>{t && t('companyPage.contactus')}</SectionTitle>
        
        {address && visibleMap ?
          <Box color="#15476D" pb={2}>
            <Typography variant="h6">{`${address} ${city}`}</Typography>
          </Box>
        : null }
        {phoneNumber && visiblePhone ?
          <Box color="#15476D" pb={2}>
              <a href={`tel:${phoneNumber}`} style={{textDecoration:'none'}}>
                <Typography variant="h6">
                  {phoneNumber}
                </Typography>
              </a>
          </Box>
        : null }
        {email ?
        <Box color="#15476D" pb={2}>
            <a href={`mailto:${email}`}>
              <Typography variant="h6" style={{ textDecoration:'none' }}>
                {email}
              </Typography>
            </a>
        </Box>
        : null}

        {(facebookPage || instagramPage || twitterPage) && (
          <Box py={5}>
            <SectionTitle>{t && t('companyPage.followUs')}</SectionTitle>
            <SocialIcons
              color="#089B9B"
              bgcolor="#fafafa"
              mb={2}
              facebookLink={facebookPage}
              instagramLink={instagramPage}
              twitterLink={twitterPage}
            />
          </Box>
        )}
      </Box>
      {/* get in touch form */}
      <Box width={{ xs: '100%', md: '50%' }}>
        <SectionTitle pb={4}>{t && t('companyPage.getInTouch')}</SectionTitle>
        <Box>
          <Box
            pb={2}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box width="45%">
              <TextField
                fullWidth
                variant="outlined"
                id="firstName"
                label={t && t("profile-comp.first")}
                value={formData.firstName}
                onChange={(e) =>
                  setFormData({ ...formData, firstName: e.target.value })
                }
              />
            </Box>

            <Box width="45%">
              <TextField
                fullWidth
                variant="outlined"
                id="lastName"
                label={t && t("profile-comp.first")}
                value={formData.lastName}
                onChange={(e) =>
                  setFormData({ ...formData, lastName: e.target.value })
                }
              />
            </Box>
          </Box>

          <Box
            pb={2}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box width="45%">
              <TextField
                fullWidth
                variant="outlined"
                id="email"
                label={t && t('reservations.email')}
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
              />
            </Box>

            <Box width="45%">
              <TextField
                fullWidth
                variant="outlined"
                id="phone"
                label={t && t('reservations.phoneNumber')}
                value={formData.phone}
                onChange={(e) =>
                  setFormData({ ...formData, phone: e.target.value })
                }
              />
            </Box>
          </Box>

          <Box pb={2}>
            <TextField
              fullWidth
              variant="outlined"
              id="subject"
              label="Message Title"
              value={formData.subject}
              onChange={(e) =>
                setFormData({ ...formData, subject: e.target.value })
              }
            />
          </Box>
          <Box pb={2}>
            <TextField
              multiline
              rows={8}
              fullWidth
              variant="outlined"
              id="content"
              label="Message"
              value={formData.content}
              onChange={(e) =>
                setFormData({ ...formData, content: e.target.value })
              }
            />
          </Box>
        </Box>
        <Box textAlign="right">
            <Button size="large" variant="contained" color="primary" onClick={sendEmail}>
              {t && t('companyPage.send')}
            </Button>
        </Box>
      </Box>

      <AlertMessage
        {...{
          alertType,message,snackOpen:openAlert,
          closeAlert
        }}
      />

      <Backdrop className={classes.backdrop} open={loading}>
        <ColorCircularProgress />
      </Backdrop>
    </Box>
  );
};

const Location = ({ companyData }) => {
  return (
    <Box pb={4} height="400px" width="90%" m="auto" mb="100px">
      <Map
        longitude={companyData?.longitude}
        latitude={companyData?.latitude}
      />
    </Box>
  );
};

export default Contact;


export {
  SimpleHeader
};